import Vue from "vue";
// import axios from "../../axios-middleware";
import axios from 'axios';
import i18n from "@/lang/i18n.js";
import HELPERS from "@/modules/OperatorPanel/helpers";

const state = {
  operator_panel: {
    chatRoomClient: null,
    chatRoomClients: {},
    clientHistory: [],
    showHistoryItemId: '',
    showHistoryItemIdRight: '',

    clientStepsHistory: [],
    clientStepsHistoryCounter: 0,
    clientStepsHistoryShowMore: false,

		same_contacts_search_list: [],
  },
};

const mutations = {
  OP_SET_CHAT_ROOM_CLIENT(state, clientInfo) {
    state.operator_panel.chatRoomClient = clientInfo;
  },

	OP_SET_CHAT_ROOM_CLIENTS(state, data) {
		const {client_id, client} = data;
		Vue.set(state.operator_panel.chatRoomClients, client_id, client)
	},
	OP_CLEAR_CHAT_ROOM_CLIENTS(state) {
		state.operator_panel.chatRoomClients = {}
	},

  OP_SET_CLIENT_HISTORY(state, history) {
    state.operator_panel.clientHistory = history;
  },
  OP_SET_CLIENT_STEPS_HISTORY(state, history) {
    state.operator_panel.clientStepsHistory = [...history, ...state.operator_panel.clientStepsHistory]
  },
  OP_RESET_CLIENT_STEPS_HISTORY(state, history) {
    state.operator_panel.clientStepsHistory = [...history]
  },
  OP_CLEAR_CLIENT_STEPS_HISTORY(state) {
    state.operator_panel.clientStepsHistory = []
  },
  OP_SET_CLIENT_STEPS_HISTORY_COUNTER(state, length) {
    state.operator_panel.clientStepsHistoryCounter += length;
  },
  OP_CLEAR_CLIENT_STEPS_HISTORY_COUNTER(state) {
    state.operator_panel.clientStepsHistoryCounter = 0;
  },
  OP_SET_CLIENT_STEPS_HISTORY_SHOW_MORE(state, status) {
    state.operator_panel.clientStepsHistoryShowMore = status
  },

  OP_SET_SHOW_HISTORY_ITEM_ID (state, chatId) {
    state.operator_panel.showHistoryItemId = chatId
  },

  OP_SET_SHOW_HISTORY_ITEM_ID_RIGHT (state, chatId) {
    state.operator_panel.showHistoryItemIdRight = chatId
  },

	OP_SET_SAME_CONTACTS_SEARCH_LIST (state, payload) {
		state.operator_panel.same_contacts_search_list = payload
	},
};

const actions = {
  async opGetClientInfo({ commit, getters }, clientId) {
    if (!clientId) {
      commit("OP_SET_CHAT_ROOM_CLIENT", null);
      return;
    }

    const url = `${process.env.VUE_APP_CONSTRUCTOR_URL}/kw/operator_panel/client/${clientId}/info/`;
		const params = {chat_room_id: getters.opChatRoomInfo?.id};
    const clientInfo = await axios
      .post(url, params)
      .then((response) => {
				if(response.data?.status === 'success') {
					let client = response.data?.data?.client || {}

					if(response.data?.data?.chat_room_contact) {
						client['chat_room_contact'] = response.data.data.chat_room_contact
					}
					return client;
				} else if(response.data?.status === 'error') {
					HELPERS.handleError([
						response.data,
						i18n.t('common.error') + '!',
						i18n.t('common.error_get') + `${response?.data?.message ? ' (' + response.data.message + ')' : ''}`
					]);
					return null;
				} else {
					return null
				}

      })
      .catch((err) => {
        HELPERS.handleError([
					err,
					i18n.t('common.error') + '!',
					i18n.t('common.error_get') + `${err?.response?.data?.message ? ' (' + err.response.data.message + ')' : ''}`
				]);
        return null;
      });

    commit("OP_SET_CHAT_ROOM_CLIENT", clientInfo);
		commit("OP_SET_CHAT_ROOM_CLIENTS", {
			client_id: clientId,
			client: clientInfo,
		});

		return clientInfo
  },

	opClearClientInfo({commit}) {
		commit("OP_SET_CHAT_ROOM_CLIENT", null);
		commit("OP_CLEAR_CHAT_ROOM_CLIENTS");
	},

	async opGetClientsInfo({ commit, getters }, data) {
		const { client_id, chat_room_id } = data;

		if (!client_id) return;

		const url = `${process.env.VUE_APP_CONSTRUCTOR_URL}/kw/operator_panel/client/${client_id}/info/`;
		const params = {};

		if(chat_room_id) params['chat_room_id'] = chat_room_id

		const clientInfo = await axios
			.post(url, params)
			.then((response) => {
				let client = response.data?.data?.client || {}

				if(response.data?.data?.chat_room_contact) {
					client['chat_room_contact'] = response.data.data.chat_room_contact
				}
				return client;
			})
			.catch((err) => {
				HELPERS.handleError([err, i18n.t('common.error'), i18n.t('common.error_get') + " opGetClientInfo"]);
				return null;
			});

		commit("OP_SET_CHAT_ROOM_CLIENTS", {
			client_id: client_id,
			client: clientInfo,
		});
	},

  async opGetClientHistory({ commit }, clientId) {
    if (!clientId) {
      commit("OP_SET_CHAT_ROOM_CLIENT", null);
      commit("OP_SET_CLIENT_HISTORY", []);
      return;
    }

    const url = `${process.env.VUE_APP_CONSTRUCTOR_URL}/kw/operator_panel/client/${clientId}/chat_rooms_history/`;

    const history = await axios
      .get(url)
      .then((response) => {
        return response.data?.data?.chatRooms?.slice(0, 400) || [];
      })
      .catch((err) => {
        HELPERS.handleError([
					err,
					i18n.t('common.error') + '!',
					i18n.t('common.error_get') + `${err?.response?.data?.message ? ' (' + err.response.data.message + ')' : ''}`
				]);
        return null;
      });

    commit("OP_SET_CLIENT_HISTORY", history);
  },

	opClearClientHistory({ commit }) {
		commit("OP_SET_CLIENT_HISTORY", []);
	},

  async opGetHistoryItem(_context, chatRoomId) {
    if (!chatRoomId) return [];

    const url = `${process.env.VUE_APP_CONSTRUCTOR_URL}/kw/operator_panel/chat_room/${chatRoomId}/messages/list?archive=1`;

    const chatRoomInfo = await axios
      .get(url)
      .then((response) => {
        const messages = response.data?.data?.messages || [];
        const participants = response.data?.data?.participants || [];

        return { messages, participants };
      })
      .catch((err) => {
        HELPERS.handleError([err, i18n.t('common.error'), i18n.t('common.error_get')]);
        return { messages: [], participants: [] };
      });

    return chatRoomInfo;
  },
  /**
   * Create client request
   * @param {Object} params - Request params
   * @returns {Boolean} - Success status
   */
  async opCreateClient(_context, params) {
    const url = `${process.env.VUE_APP_CONSTRUCTOR_URL}/kw/operator_panel/create_update_reguser/`;

    const success = await axios({
      url,
      method: "POST",
      data: params,
    })
      .then((response) => {
        return response.data?.status === "success";
      })
      .catch((err) => {
        HELPERS.handleError([
          err,
          i18n.t("common.error"),
          i18n.t("common.error_get"),
        ]);

        return false;
      });

    return success;
  },

  async opBlockClient(_context, params) {
    const url = `${process.env.VUE_APP_CONSTRUCTOR_URL}/kw/operator_panel/ban_reguser/`;

    const success = await axios({
      url,
      method: "POST",
      data: params,
    })
      .then((response) => {
        return response.data?.status === "success";
      })
      .catch((err) => {
        HELPERS.handleError([
          err,
          i18n.t("common.error"),
          i18n.t("common.error_get"),
        ]);

        return false;
      });

    return success;
  },

  opSetShowHistoryItemId({ commit }, chatId) {
    commit('OP_SET_SHOW_HISTORY_ITEM_ID', chatId)
  },

  opSetShowHistoryItemIdRight({ commit }, chatId) {
    commit('OP_SET_SHOW_HISTORY_ITEM_ID_RIGHT', chatId)
  },

  opCLearClientStepsHistory({commit, state}) {
    commit("OP_CLEAR_CLIENT_STEPS_HISTORY_COUNTER");
    commit("OP_SET_CLIENT_STEPS_HISTORY_SHOW_MORE", false);
    commit("OP_CLEAR_CLIENT_STEPS_HISTORY");
  },

  async opAxiosClientStepsHistory({ commit, state }, user_id= null) {
    let data = {};
    let limitElements = 50;

    if(user_id) {
      data = {
        user_id: user_id,
      }
    } else {
      if (
        !state.operator_panel?.chatRoomClient?.bot_id
        && !state.operator_panel.chatRoomClient.channels[0]?.kw_channel
        && !state.operator_panel.chatRoomClient.channels[0]?.kw_chat_id
      ) {
        // commit("OP_SET_CHAT_ROOM_CLIENT", null);
        commit("OP_SET_CLIENT_STEPS_HISTORY", []);
        commit("OP_SET_CLIENT_STEPS_HISTORY_COUNTER", 0);
        return;
      } else {
        data = {
          bot_id: state.operator_panel?.chatRoomClient?.bot_id,
          channel: state.operator_panel.chatRoomClient.channels[0]?.kw_channel,
          chat_id: state.operator_panel.chatRoomClient.channels[0]?.kw_chat_id,
        }
      }
    }


    const url = `${state.engine_settings.active_url}/kw/logs/list/`;

    const stepsHistory = await axios({
        url,
        method: "POST",
        data: data,
        params: {
          limit: limitElements,
          offset: state.operator_panel.clientStepsHistoryCounter,
        }
      })
      .then((response) => {
        return response.data?.data?.logs || [];
      })
      .catch((err) => {
        HELPERS.handleError([
					err,
					i18n.t('common.error') + '!',
					i18n.t('common.error_get') + `${err?.response?.data?.message ? ' (' + err.response.data.message + ')' : ''}`
				]);
        return null;
      });



    let payloadLength = stepsHistory.length


    if (payloadLength < limitElements ) {
      commit("OP_SET_CLIENT_STEPS_HISTORY_SHOW_MORE", false);
    } else {
      commit("OP_SET_CLIENT_STEPS_HISTORY_SHOW_MORE", true);
    }

    commit("OP_SET_CLIENT_STEPS_HISTORY_COUNTER", payloadLength);
    commit("OP_SET_CLIENT_STEPS_HISTORY", stepsHistory.reverse());
  },

  async opAxiosResetClientStepsHistory({ commit, state }, user_id= null) {
    let data = {};
    let limitElements = 50;

    commit("OP_SET_CLIENT_STEPS_HISTORY", []);
    commit("OP_CLEAR_CLIENT_STEPS_HISTORY_COUNTER");


    if(user_id) {
      data = {
        user_id: user_id,
      }
    } else {
      if (
        !state.operator_panel?.chatRoomClient?.bot_id
        && !state.operator_panel.chatRoomClient?.channels[0]?.kw_channel
        && !state.operator_panel.chatRoomClient?.channels[0]?.kw_chat_id
      ) {
        return;
      } else {
        data = {
          bot_id: state.operator_panel?.chatRoomClient?.bot_id,
          channel: state.operator_panel.chatRoomClient.channels[0]?.kw_channel,
          chat_id: state.operator_panel.chatRoomClient.channels[0]?.kw_chat_id,
        }
      }
    }

    const url = `${state.engine_settings.active_url}/kw/logs/list/`;

    const stepsHistory = await axios({
      url,
      method: "POST",
      data: data,
      params: {
        limit: limitElements,
        offset: state.operator_panel.clientStepsHistoryCounter,
      }
    })
      .then((response) => {
        return response.data?.data?.logs || [];
      })
      .catch((err) => {
        HELPERS.handleError([
					err,
					i18n.t('common.error') + '!',
					i18n.t('common.error_get') + `${err?.response?.data?.message ? ' (' + err.response.data.message + ')' : ''}`
				]);
        return null;
      });



    let payloadLength = stepsHistory.length

    if (payloadLength < limitElements ) {
      commit("OP_SET_CLIENT_STEPS_HISTORY_SHOW_MORE", false);
    } else {
      commit("OP_SET_CLIENT_STEPS_HISTORY_SHOW_MORE", true);
    }

    commit("OP_SET_CLIENT_STEPS_HISTORY_COUNTER", payloadLength);
    commit("OP_RESET_CLIENT_STEPS_HISTORY", stepsHistory.reverse());
  },

	async opAxiosClientEdit(_, data) {
		const { op_client_id, params } = data;
		let url = `${process.env.VUE_APP_CONSTRUCTOR_URL}/kw/operator_panel/client/edit/${op_client_id}`

		return await axios
			.post(url, params)
			.then((response) => {
				return response.data?.data || null;
			})
			.catch((err) => {
				HELPERS.handleError([
					err,
					i18n.t('common.error'),
					i18n.t('common.error_get')
				]);

				return null;
			});
	},

	// Contacts axios
	async opAxiosClientsPreviewSearch({ commit }, params) {

		const url = `${process.env.VUE_APP_CONSTRUCTOR_URL}/kw/contacts/search_preview/`;
		// const params = {
		// 	client_id: client_id,
		// 	auto: 'true',
		// }

		return await axios
			.get(url, { params })
			.then((response) => {
				return response.data?.data || [];
			})
			.catch((err) => {
				HELPERS.handleError([
					err,
					i18n.t('common.error'),
					i18n.t('common.error_get')
				]);

				return [];
			});
	},
	async opAxiosClientsSearch({ commit }, params) {
		commit('OP_SET_SAME_CONTACTS_SEARCH_LIST', [])

		const url = `${process.env.VUE_APP_CONSTRUCTOR_URL}/kw/contacts/search/`;

		return await axios
			.post(url, params)
			.then((response) => {
				commit('OP_SET_SAME_CONTACTS_SEARCH_LIST', response.data?.data?.contacts || [])

				return response.data?.data?.contacts || [];
			})
			.catch((err) => {
				HELPERS.handleError([
					err,
					i18n.t('common.error'),
					i18n.t('common.error_get')
				]);

				return [];
			});

	},
	async opAxiosAddClientToContact(_, data) {
		const { id, params} = data;

		// id: :op_client_id
		const url = `${process.env.VUE_APP_CONSTRUCTOR_URL}/kw/contacts/edit/${id}/add_client/`;

		return await axios
			.post(url, params)
			.then((response) => {
				return response || null;
			})
			.catch((err) => {
				HELPERS.handleError([
					err,
					i18n.t('common.error'),
					i18n.t('common.error_get')
				]);

				return null;
			});
	},
	async opAxiosRemoveClientFromContact(_, id) {
		// id:contact_id
		const url = `${process.env.VUE_APP_CONSTRUCTOR_URL}/kw/contacts/edit/${id}/clear_client/`;

		return await axios
			.post(url)
			.then((response) => {
				return response || null;
			})
			.catch((err) => {
				HELPERS.handleError([
					err,
					i18n.t('common.error'),
					i18n.t('common.error_get')
				]);

				return null;
			});
	},
	async opAxiosGetDialoglink(_, data) {
		const {
			bot_id,
			channel,
			chat_id,
		} = data

		const uriEncodeChatId = encodeURIComponent(chat_id);

		const url = `${process.env.VUE_APP_CONSTRUCTOR_URL}/kw/operator_panel/chat_rooms/${bot_id}/${channel}/${uriEncodeChatId}`;

		return await axios( {
				url,
				method: "GET",
		})
		.then(response => {
			return response?.data?.data?.chat_rooms || []
		})
		.catch((err) => {
			HELPERS.handleError([
				err,
				i18n.t("common.error"),
				i18n.t("common.error_get"),
		]);

			return false;
		});
	},

};

const getters = {
  opChatRoomClient: (state) => state.operator_panel.chatRoomClient,
  opChatRoomClients: (state) => state.operator_panel.chatRoomClients,

  opClientHistory: (state, getters) => {
    const rawHistory = state.operator_panel.clientHistory;
    const getRoom = (item) => item.chat_room;

    // const history = rawHistory.map(getRoom);
    const history = rawHistory || [];

    const subjects = getters.opSubjectList;
    const users = getters.opAllUsersList;

    const options = { history, subjects, users };
    const normHistory = HELPERS.rebuildChatRooms(options);

    return normHistory;
  },

  opGetShowHistoryItemId: (state) => state.operator_panel.showHistoryItemId,
  opGetShowHistoryItemIdRight: (state) => state.operator_panel.showHistoryItemIdRight,
  opClientStepsHistory: (state) => state.operator_panel.clientStepsHistory,
  opClientStepsHistoryCounter: (state) => state.operator_panel.clientStepsHistoryCounter,
  opClientStepsHistoryShowMore: (state) => state.operator_panel.clientStepsHistoryShowMore,

	opSameContactsSearchList:(state) => state.operator_panel.same_contacts_search_list,
};

export default {
  state,
  mutations,
  actions,
  getters,
};
